import type { SmsConsentData } from "../../services/api";

/** `{{phone}}` in the published intro is the masked number. */
export function smsConsentIntro(
  consent: SmsConsentData,
  fallback: string,
): string {
  const intro = consent.entries[0]?.introMarkdown?.trim();
  const phone = consent.maskedPhone ?? "";
  if (!intro) return fallback;
  return intro.replace(/\{\{\s*phone\s*\}\}/g, phone);
}
